export default __webpack_public_path__ + "static/og-default-308659ce92a39fe7263d70c978100aff.png";